import React from 'react';
import { Link } from 'react-router-dom';
import { images } from '../data/images';
import { ritualSteps } from '../data/ritual';
import { products } from '../data/products';
export function About() {
  return <>
      <section className="mx-auto grid max-w-7xl gap-12 px-5 py-14 lg:grid-cols-12 lg:gap-16 lg:px-8 lg:py-20" data-id="element-379" data-mp="29kojpjywhqva">
        <div className="flex flex-col justify-center lg:col-span-6" data-id="element-380" data-mp="2ej87zr0yveqt">
          <h1 className="font-display text-4xl uppercase leading-[0.95] tracking-display sm:text-6xl" data-id="element-381" data-mp="32817fxgss4q6">
            Terug naar <em className="italic text-pink" data-id="element-382" data-mp="376ci2aex2j9g">de basis</em>
          </h1>
          <div className="mt-8 space-y-5 text-lg leading-relaxed text-muted" data-id="element-383" data-mp="2samrdyysdhye">
            <p data-id="element-384" data-mp="2x97ss1pry7of">
              Amira groeide op in Aït Baha, tussen de heuvels van de Anti-Atlas. Cosmetica bestond daar niet uit chemische producten
              uit kastjes, maar uit henna, arganolie en gedroogde planten — gemengd door haar oma.
            </p>
            <p data-id="element-385" data-mp="1lvm3mgjx062w">
              Op de souk leerde ze de zeep, kruiden, oliën en geurende waters kennen. Later zag ze diezelfde ingrediënten terug in
              hedendaagse beautyproducten, verpakt in grote verhalen en grote beloftes.
            </p>
            <p className="text-ink" data-id="element-386" data-mp="23i88udtmk2h9">
              Een product hoef je niet mooier te maken dan het is. Je moet weten wat het is, wat het doet en hoe je het gebruikt.
            </p>
          </div>
        </div>
        <img src={images.story} alt="Twee generaties mengen henna in een terracotta schaal" className="aspect-[4/5] w-full rounded-3xl object-cover lg:col-span-6" data-id="element-387" data-mp="2dg4i10304ncq" />
      </section>

      <section id="ritueel" className="bg-surface" data-id="element-388" data-mp="2m8pwi3zlo7vr">
        <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 lg:grid-cols-12 lg:gap-16 lg:px-8 lg:py-24" data-id="element-389" data-mp="2m8g5qe6qdwp0">
          <div className="lg:col-span-5" data-id="element-390" data-mp="2i85x0trk0s6g">
            <div className="lg:sticky lg:top-24" data-id="element-391" data-mp="2w6m4wo15koq6">
              <h2 className="font-display text-3xl uppercase leading-[0.98] tracking-display sm:text-5xl" data-id="element-392" data-mp="2w7f4n51p2dyt">Traditionele verzorging in 9 stappen</h2>
              <p className="mt-4 text-lg text-muted" data-id="element-393" data-mp="1ov6arkbfcr4d">Geïnspireerd op de hammam. Elke stap heeft een doel en een product dat precies dat doet.</p>
              <Link to="/product/hammam-ritueel-set" className="mt-8 inline-flex h-14 items-center whitespace-nowrap rounded-full bg-ink px-7 text-base font-medium text-white transition-colors duration-150 hover:bg-berry" data-id="element-394" data-mp="1swrfujhpw140">
                Shop de Hammam Ritueel Set
              </Link>
            </div>
          </div>
          <ol className="lg:col-span-7" data-id="element-395" data-mp="2cjfpk2a80em0">
            {ritualSteps.map((s, i) => <li key={s.title} className="grid grid-cols-[3rem_1fr] gap-4 border-t border-line py-6 last:border-b" data-id="element-396" data-mp="2glaqv6s5irzs" data-mpi={i}>
                <span className="font-display text-2xl text-pink tabular-nums" data-id="element-397" data-mp="2ll5f12kjl3h5">{i + 1}</span>
                <div data-id="element-398" data-mp="m8kwyp1s9ise">
                  <h3 className="text-xl font-semibold tracking-tight" data-id="element-399" data-mp="m92z22b4mr88">{s.title}</h3>
                  <p className="mt-1 text-muted" data-id="element-400" data-mp="r7xin6gx4jte">{s.text}</p>
                  {s.products.length > 0 && <ul className="mt-3 flex flex-wrap gap-2" data-id="element-401" data-mp="jo530ts4jl65">
                      {s.products.map(name => {
                  const p = products.find(x => x.name === name);
                  if (!p) return null;
                  return <li key={name} data-id="element-402" data-mp="4yz5da8xq30d">
                            <Link to={`/product/${p.slug}`} className="flex items-center gap-2 rounded-full border border-line bg-white py-1 pl-1 pr-3 text-sm transition-colors duration-150 hover:border-pink hover:text-pink" data-id="element-403" data-mp="501wnja667gt">
                              <img src={p.image} alt="" className="h-6 w-6 rounded-full object-cover" data-id="element-404" data-mp="sq4ktoayqta5" />
                              {p.name}
                            </Link>
                          </li>;
                })}
                    </ul>}
                </div>
              </li>)}
          </ol>
        </div>
      </section>
    </>;
}